import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { AuthService } from '../../services/auth.service';
import { Button } from "primeng/button";
import { Card } from "primeng/card";
import { InputTextModule } from 'primeng/inputtext';
import { Message } from "primeng/message";
import { PasswordModule } from 'primeng/password';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
    imports: [
    ReactiveFormsModule,
    TranslatePipe,
    InputTextModule,
    PasswordModule,
    Card,
    Button,
    Message
],
    selector: 'app-sign-in-component',
    styleUrl: './sign-in.component.scss',
    templateUrl: './sign-in.component.html',
})
export class SignInComponent {
    private authService = inject(AuthService);
    private router = inject(Router);
    private fb = inject(FormBuilder);

    form: FormGroup;
    error: string | null = null;
    readonly hide = signal(true);

    constructor() {
        this.form = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]],
        });
    }

    login(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched(); // show errors if user just clicked submit
            return;
        }

        const { email, password } = this.form.value;
        this.authService.login(email, password).subscribe((error) => {
            if (!error) {
                // ✅ Login successful → redirect
                this.router.navigate(['/dashboard']);
            } else {
                // handle error (show toast, etc.)
                console.error('Login failed:', error);
            }
        });
    }

    clickEvent(event: MouseEvent): void {
        this.hide.set(!this.hide());
        event.stopPropagation();
    }
}
